'use client';
import React, { useEffect } from 'react';
import Logo from './Logo';
import Headroom from 'headroom.js';
import Image from 'next-export-optimize-images/image';
import CallToActionButtonContent from '@/components/landingPage/CallToActionButtonContent';
import TrustboxWidget from '@/components/landingPage/TrustboxWidget';

interface HeaderProps {
  showButton?: boolean;
  showButtonOnMobile?: boolean;
  buttonText?: string;
  showTagline?: boolean;
  showLogos?: boolean;
}

export default function Header({
  showButton = false,
  showButtonOnMobile = false,
  buttonText,
  showTagline = true,
  showLogos = true,
}: HeaderProps) {
  useEffect(() => {
    if (window.innerWidth >= 768) {
      const headroomElement = document.querySelector('.headroom') as HTMLElement;
      if (headroomElement) {
        const headroom = new Headroom(headroomElement);
        headroom.init();
      }
    }
  }, []);

  return (
    <header className="mainHeader">
      <nav>
        <div className="flex flex-col h-full">
          <div className="bg-ovi-ivory-2">
            <div className="centerMaxWidthContainer h-[30px]">
              <div className="flex justify-center items-center h-full w-full">
                <div className="text-black text-center text-[12px] font-bold leading-[150%] tracking-[0.15px]">
                  Über 1 Million Menschen vertrauen Oviva. Du auch?
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between max-w-[1284px] mx-auto w-full">
            <div className="flex flex-row items-center gap-5 py-6 md:mx-0 lg:w-[70%] justify-between px-[20px] lg:!pr-0 md:pl-[40px] xl:pl-[60px]">
              <Logo className="logo shrink-0" />

              {showLogos && (
                <div className="flex flex-row items-center gap-12">
                  <div className="hidden lg:block">
                    <span className="text-[#002926] text-[12px] font-semibold leading-[150%] tracking-[0.15px]">
                      Bekannt aus:
                    </span>
                    <div className="flex flex-row items-center gap-2">
                      <Image
                        className="w-[45px] h-[27px]"
                        src="/images/crowded_header/zdf_logo.png"
                        width={45}
                        height={27}
                        alt="ZDF Logo"
                      />
                      <Image
                        className="w-[29px] h-[18px]"
                        src="/images/crowded_header/sueddeutsche_zeitung_logo.png"
                        width={45}
                        height={28}
                        alt="Süddeutsche Zeitung Logo"
                      />
                      <Image
                        className="w-[58px] h-[11px]"
                        src="/images/crowded_header/rtl_logo.png"
                        width={58}
                        height={11}
                        alt="RTL Logo"
                      />
                      <Image
                        className="w-[71px] h-[18px]"
                        src="/images/crowded_header/apothekenumschau_logo.png"
                        width={71}
                        height={18}
                        alt="Apothekenumschau Logo"
                      />
                    </div>
                  </div>
                  <TrustboxWidget />
                </div>
              )}
            </div>

            {showButton && (
              <div
                className={`${showButtonOnMobile ? 'block' : 'hidden md:block'} gap-2 border-t border-ovi-ivory-2 pt-4 pb-5 px-[18px] lg:!pl-0 md:border-none`}
              >
                <div className="flex flex-col w-full items-center gap-2">
                  {showTagline && (
                    <span className="text-[#002926] text-center text-[16px] font-bold leading-[150%] tracking-[0.15px]">
                      Abnehmen? App nehmen!
                    </span>
                  )}

                  <div className="block">
                    <CallToActionButtonContent
                      className="headerCta button !px-8 !py-2 min-w-[220px]"
                      defaultText={buttonText}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}
